import styled from 'styled-components'

export const SwitcherContainer = styled.div``

export const SwitcherCheckbox = styled.input<{ checked: boolean }>`
  height: 0;
  width: 0;
  display: none;
  ${({ checked }) =>
    checked &&
    `
    left: calc(100% - 2px);
    transform: translateX(-100%);
  `}
`

export const SwitcherLabel = styled.label<{ checked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 48px;
  height: 16px;
  background:  #dadee3;
  border-radius: 100px;
  position: relative;
  transition: background-color 0.2s;
  ${({ checked }) =>
    checked &&
    `
    left: calc(100% - 2px);
    transform: translateX(-100%);
    background:  #dadee3
  `}
`

export const SwitcherSpan = styled.span<{ checked: boolean }>`
  content: '';
  position: absolute;
  top: -3px;
  left: 0px;
  width: 24px;
  height: 24px;
  border-radius: 45px;
  transition: 0.2s;
  background: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  ${({ checked }) =>
    checked &&
    `
    left: calc(100% - 2px);
    transform: translateX(-100%);
  `}
`
